import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle, Cancel, HourglassEmpty, DoNotDisturb } from "@mui/icons-material";

function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Fetching the totalCounts data from the API
    axios.get("https://api.raoosastro.com/totalCounts")
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the data:", error);
      });
  }, []);
  // useEffect(() => {
  //   // Fetching the last completed token data from the API
  //   axios.get("https://api.raoosastro.com/lastCompletedToken")
  //     .then(response => {
  //       setData(response.data);
  //     })
  //     .catch(error => {
  //       console.error("There was an error fetching the data:", error);
  //     });
  // }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        
        {/* Today's Counts Section */}
        <Grid container spacing={3}>
          {/* Total Users Count */}
          <Grid item xs={12}>
            <MDBox mb={2}>
              <h4>Users</h4>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon={<CheckCircle />}
                title="Total Users"
                count={data?.totalUsers || 0}
                percentage={{
                  color: "info",
                  amount: "+8%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>
          
          {/* Appointments Heading */}
          <Grid item xs={12}>
            <MDBox mb={2}>
              <h4>Appointments</h4>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon={<CheckCircle />}
                title="Running Token"
                count={data?.lastCompletedToken?.tokenNo || 0}  
                percentage={{
                  color: "info",
                  amount: "+8%",
                  label: "than yesterday", // Adjust as needed
                }}
              />
            </MDBox>
          </Grid>
          {/* Completed Token Count */}
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon={<CheckCircle />}
                title="Overall"
                count={data?.overallCount || 0}
                percentage={{
                  color: "success",
                  amount: "+5%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon={<CheckCircle />}
                title="Completed"
                count={data?.statusSummary?.completed || 0}
                percentage={{
                  color: "success",
                  amount: "+5%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>

          {/* Not Responded Token Count */}
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon={<DoNotDisturb />}
                title="Not Responded"
                count={data?.statusSummary?.notresponded || 0}
                percentage={{
                  color: "error",
                  amount: "-2%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>

          {/* Waiting Token Count */}
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon={<HourglassEmpty />}
                title="Waiting"
                count={data?.statusSummary?.waiting || 0}
                percentage={{
                  color: "warning",
                  amount: "+10%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>

          {/* Cancelled Token Count */}
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon={<Cancel />}
                title="Cancelled"
                count={data?.statusSummary?.cancelled || 0}
                percentage={{
                  color: "error",
                  amount: "-3%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
